export const GET_USER_LIST = 'GET_USER_LIST';
export const SET_USER_LIST = 'SET_USER_LIST';
export const SET_SELECTED_USER = 'SET_SELECTED_USER';
export const GET_USER_DETAIL = 'GET_USER_DETAIL';
export const SET_USER_DETAIL = 'SET_USER_DETAIL';
export const UPDATE_USER = 'UPDATE_USER';
export const DELETE_USER = 'DELETE_USER';
export const UPDATE_PWD = 'UPDATE_PWD';
